//#region src/constants.ts
var e = typeof OVERRIDE_PACKAGE_VERSION < "u" ? OVERRIDE_PACKAGE_VERSION : "0.3.0";
//#endregion
export { e as APP_VERSION };

//# sourceMappingURL=constants.js.map